import { Language } from "src/app/transloco.config";

export const getLanguageValues = (): string[] => {
  return Object.values(Language);
};
